module.exports = __webpack_public_path__ + "img/audio_gifA.1560a63a.gif";